import { Crown, Target, Users, Award } from "lucide-react";

const VALUES = [
    { icon: Crown, title: "Royalty", desc: "Carry yourself like a king on and off the court." },
    { icon: Target, title: "Discipline", desc: "Show up early. Work late. Repeat." },
    { icon: Users, title: "Brotherhood", desc: "We rise together — or we don't rise at all." },
    { icon: Award, title: "Championship", desc: "Compete for hardware. Always." },
];

export default function About() {
    return (
        <div data-testid="about-page" className="grain">
            <section className="relative h-[60vh] min-h-[420px] overflow-hidden hero-clip">
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{
                        backgroundImage:
                            "url('https://images.pexels.com/photos/10412806/pexels-photo-10412806.jpeg')",
                    }}
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/30" />
                <div className="relative max-w-7xl mx-auto px-5 md:px-10 h-full flex items-end pb-16">
                    <div>
                        <div className="text-gold text-xs tracking-[0.4em] uppercase font-bold mb-4">Our Mission</div>
                        <h1 data-testid="about-title" className="h-display text-6xl md:text-8xl">Long Live<br /><span className="text-gold">The Kings.</span></h1>
                    </div>
                </div>
            </section>

            <section className="max-w-5xl mx-auto px-5 md:px-10 py-24">
                <p className="text-2xl md:text-3xl text-white leading-relaxed font-light">
                    Purple Kings is more than a basketball team — we are a movement built on the belief that <span className="text-gold">talent is universal, but opportunity is not.</span> ABA professional basketball, proudly representing Texas since 2024.
                </p>
                <div className="h-px w-24 bg-gold my-12" />
                <div className="grid md:grid-cols-2 gap-10">
                    <div>
                        <div className="h-display text-3xl mb-4">Our Story</div>
                        <p className="text-white/80 leading-relaxed">
                            Born in Houston in 2024. Forged across Texas. Won the <span className="text-gold">ABA South Central Wild Card Playoffs in the 2024-2025 season</span> — and have racked up 45 wins and counting in the league since. From rec gyms to sold-out arenas, the kingdom keeps growing.
                        </p>
                    </div>
                    <div>
                        <div className="h-display text-3xl mb-4">Our Mission</div>
                        <p className="text-white/80 leading-relaxed">
                            Develop pro-caliber athletes. Engage the community. Bring championship-level basketball to Texas — and never apologize for the swagger that comes with the crown. Averaging 120.1 PPG and built to score.
                        </p>
                    </div>
                </div>
            </section>

            <section className="border-y border-line bg-bg-soft py-24">
                <div className="max-w-7xl mx-auto px-5 md:px-10">
                    <div className="text-gold text-[10px] tracking-[0.4em] uppercase font-bold mb-4">The Standards</div>
                    <h2 className="h-display text-5xl md:text-6xl mb-12">Kingdom Code</h2>
                    <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-4">
                        {VALUES.map((v, i) => (
                            <div key={i} className="card-flat p-6" data-testid={`value-${i}`}>
                                <v.icon className="text-gold" size={24} />
                                <div className="h-display text-2xl mt-5">{v.title}</div>
                                <p className="text-ink mt-3 text-sm leading-relaxed">{v.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
